module.exports = __webpack_public_path__ + "static/media/taptheballpitch.85716bd4.png";